import React, { useState } from 'react';
import { Headphones, ChevronDown, ChevronUp, ExternalLink } from 'lucide-react';
export function ListenInsteadOfReading() {
  const [showDetails, setShowDetails] = useState(false);
  return <div className="mt-12 bg-gray-50 rounded-lg border border-gray-200 p-6" data-id="element-414" data-mp="meing6fzq90u">
      <div className="flex items-start" data-id="element-415" data-mp="hffisn3xa4te">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-purple-100 flex items-center justify-center mr-4" data-id="element-416" data-mp="hee8wlyn7od9">
          <Headphones className="w-5 h-5 text-brand-purple-600" aria-hidden="true" data-id="element-417" data-mp="walmv4jgjtk3" />
        </div>
        <div className="flex-1" data-id="element-418" data-mp="154iakns9te1m">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-419" data-mp="153ozjama42do">
            Prefer to listen instead of read?
          </h3>
          <p className="text-base text-gray-700 leading-relaxed mb-3" data-id="element-420" data-mp="113yc9gvyo4dw">
            Many devices and browsers include built-in tools that can read
            webpage text aloud. Students may also choose a third-party
            text-to-speech tool, such as NaturalReader, if they prefer listening
            to course or help content.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-421" data-mp="1xtycgjz0mg0i">
            NaturalReader offers free text-to-speech options, but Desert Sage
            Seminars does not require a specific tool and does not provide
            support for third-party extensions or apps. Please use whichever
            read-aloud option works best on your device.
          </p>

          {/* Subtle third-party links */}
          <div className="mt-4 flex flex-wrap gap-2" data-id="element-422" data-mp="2gskbzuevvz2b">
            <a href="https://www.naturalreaders.com/online/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500" data-id="element-423" data-mp="2gqzim84b2m61">
              Open NaturalReader
              <ExternalLink className="w-3.5 h-3.5 ml-1.5" aria-hidden="true" data-id="element-424" data-mp="zhauhhynjohe" />
            </a>
            <a href="https://chromewebstore.google.com/search/NaturalReader%20text%20to%20speech" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500" data-id="element-425" data-mp="vg8xl7s7joil">
              Find NaturalReader Extension
              <ExternalLink className="w-3.5 h-3.5 ml-1.5" aria-hidden="true" data-id="element-426" data-mp="1e8kz5sb1elro" />
            </a>
          </div>

          <button onClick={() => setShowDetails(open => !open)} className="mt-4 inline-flex items-center text-sm font-medium text-brand-purple-600 hover:text-brand-purple-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500 rounded" aria-expanded={showDetails} aria-controls="tts-help-details" data-id="element-427" data-mp="1n759a52j7n4a">
            How to get started
            {showDetails ? <ChevronUp className="w-4 h-4 ml-1" aria-hidden="true" data-id="element-428" data-mp="29eis0bo7akzg" /> : <ChevronDown className="w-4 h-4 ml-1" aria-hidden="true" data-id="element-429" data-mp="1voytji1nk9vy" />}
          </button>

          {showDetails && <div id="tts-help-details" className="mt-4 space-y-3 border-t border-gray-200 pt-4" data-id="element-430" data-mp="1znxxazbne0lt">
              <div data-id="element-431" data-mp="1qoszjv7wubap">
                <p className="text-sm font-semibold text-gray-900" data-id="element-432" data-mp="1qpcgb8ltqtn5">
                  Chrome / Edge
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-433" data-mp="1cqmi1pn9qnx7">
                  Install a text-to-speech browser extension such as
                  NaturalReader, return to the page you want to listen to, then
                  use the extension's play controls.
                </p>
              </div>
              <div data-id="element-434" data-mp="3b4e6wc0itn0r">
                <p className="text-sm font-semibold text-gray-900" data-id="element-435" data-mp="3b2l7nhs8m52s">
                  iPhone / iPad
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-436" data-mp="2hfgdu92h9fkw">
                  Use Apple's built-in Spoken Content or Speak Screen
                  accessibility tools.
                </p>
              </div>
              <div data-id="element-437" data-mp="27hsipi0ym627">
                <p className="text-sm font-semibold text-gray-900" data-id="element-438" data-mp="27g7mzp2wsh2r">Android</p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-439" data-mp="23fnrsr1wbnj9">
                  Use Android's Select to Speak or built-in accessibility
                  read-aloud tools.
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}